import React, { useState } from 'react';
import { Segmented, DatePicker, Space } from 'antd';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
dayjs.extend(isoWeek);

const { RangePicker } = DatePicker;

const PRESETS = [
  { label: 'Today',      value: 'today' },
  { label: 'This Week',  value: 'week' },
  { label: 'Last Week',  value: 'last-week' },
  { label: 'This Month', value: 'month' },
  { label: 'Last Month', value: 'last-month' },
  { label: 'Custom',     value: 'custom' },
];

const rangeFor = (preset) => {
  switch (preset) {
    case 'today':      return [dayjs().startOf('day'), dayjs()];
    case 'week':       return [dayjs().startOf('isoWeek'), dayjs()];
    case 'last-week':  return [dayjs().subtract(1, 'week').startOf('isoWeek'), dayjs().subtract(1, 'week').endOf('isoWeek')];
    case 'month':      return [dayjs().startOf('month'), dayjs()];
    case 'last-month': return [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')];
    default:           return null;
  }
};

const RunDateFilter = ({ onChange }) => {
  const [preset, setPreset] = useState('month');
  const [customRange, setCustomRange] = useState(null);

  const handlePreset = (val) => {
    setPreset(val);
    if (val !== 'custom') {
      onChange(rangeFor(val));
    } else if (customRange) {
      onChange(customRange);
    }
  };

  const handleCustomRange = (range) => {
    setCustomRange(range);
    if (range) onChange(range);
  };

  return (
    <Space wrap>
      <Segmented options={PRESETS} value={preset} onChange={handlePreset} />
      {preset === 'custom' && (
        <RangePicker
          value={customRange}
          onChange={handleCustomRange}
          format="DD MMM YYYY"
          allowClear={false}
          disabledDate={(d) => d && d.isAfter(dayjs(), 'day')}
        />
      )}
    </Space>
  );
};

export default RunDateFilter;
